import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useMemo } from "react";
import { TConfigSelect } from "..";

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AddLocationAltOutlinedIcon from '@mui/icons-material/AddLocationAltOutlined';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { usePermission } from "../../../../../components/PermissionGuard";

export default function SideMenu({
    select,
    handleSelect
}: SideMenuProps) {

    const colorIcon = useMemo(() => "black", [])

    const menuList: TMenuList = [
        { label: "Dashboard", icon: <DashboardOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes"), disabled: false },
        { label: "Bancos", icon: <AccountBalanceOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.bancos"), disabled: false },
        { label: "Categorias", icon: <CategoryOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.categorias"), disabled: false },
        { label: "Configurações bancárias", icon: <AccountBalanceOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.contas-bancarias"), disabled: false },
        { label: "Conta consumo", icon: <SettingsOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.conta-corrente"), disabled: false },
        { label: "Departamentos", icon: <BusinessCenterOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.departamentos"), disabled: false },
        { label: "Funções", icon: <ListAltOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.funcoes"), disabled: false },
        { label: "Locais de cobrança", icon: <AddLocationAltOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.locais-cobranca"), disabled: true },
        { label: "Operadoras de cartão", icon: <CreditCardOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.operadoras-cartao"), disabled: false },
        { label: "Rateios", icon: <AutoGraphOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.rateios"), disabled: true },
        { label: "Situações", icon: <AssignmentOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.situacoes"), disabled: false },
        { label: "Tipos de documento", icon: <FolderOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.tipos-documento"), disabled: false },
        { label: "Configuração TEF", icon: <CardMembershipIcon sx={{ color: colorIcon }} />, havePermission: usePermission("financeiro.configuracoes.tef"), disabled: false },
    ]

    return (
        <>
            <List>
                {
                    menuList.map((item, index) => {
                        const itemSelecionado = item.label === select

                        if (!item.havePermission) return <></>

                        return (
                            <ListItem
                                disablePadding
                                key={index}
                                onClick={() => !item.disabled ? handleSelect(item.label) : ''}
                                sx={{ backgroundColor: itemSelecionado ? "#F0F0F0" : "unset" }}
                            >
                                <ListItemButton
                                    disabled={item.disabled}
                                >
                                    <ListItemIcon>
                                        {item.icon}
                                    </ListItemIcon>

                                    <ListItemText primary={item.label} />

                                    <KeyboardArrowRightIcon sx={{ color: "black" }} />
                                </ListItemButton>
                            </ListItem>
                        )
                    })
                }
            </List>
        </>
    )
}

interface SideMenuProps {
    select: TConfigSelect
    handleSelect: (arg: TConfigSelect) => void
}

type TMenuList = Array<{
    label: TConfigSelect,
    icon: JSX.Element,
    havePermission: boolean
    disabled: boolean
}>

export type TDataImagens = {
    logo_image: string | null,
    cover_image: string | null,
}
